export var DEFAULT_NETWORK_ERROR_USER_MESSAGE = 'Failed to connect. Check your connection';
